<template>
  <div>
    <div  >
    <el-container>
      <el-header :height="carouselHeight+'px'" style="padding: 0px"
        ><!--头-->
        <el-carousel
          ref="carouselRef"
          arrow="always"
          :height="carouselHeight + 'px'"
          @touchstart="handleTouchStart"
          @touchend="handleTouchEnd"
        >
          <el-carousel-item
            v-for="child in carouselItems"
            :key="child"
            @click="navigateTo(child.url, global.router)"
          >
            <img :src="child.bGPic" fit="contain" :style="'width: 100%;height:'+carouselHeight+'px'" />
          </el-carousel-item>
        </el-carousel>
      </el-header>
      <el-container>
        <el-aside
          :style="
            'height:' + (scrHeight - carouselHeight) + 'px;  background-color:#3f6d7d'
          "
        class="PCView" >
          <el-menu
            active-text-color="#ffd04b"
            background-color="#497b8c"
            class="el-menu-vertical-demo"
            default-active="0"
            text-color="#fff"
            @select="handlerMenuChange"
          >
            <el-menu-item
              :index="index.toString()"
              v-for="(item, index) in menuItems"
              :key="item.name"
            >
              <i :class="'iconfont icon-' + item.icon"></i>&nbsp;{{
                item.name
              }}</el-menu-item
            >
          </el-menu>
        </el-aside>

        <el-main>
          <div class="MView">

   <el-row :gutter="10">
<el-col
 :xs="6"
 :sm="6"
 :md="4"
 :lg="3"
 :xl="1"
 v-for="(child, index)  in menuItems"
 :key="child"
 @click="handlerMenuChange(index)"
>

 <div :class="'grid-content col-4-item '+(child.name==ownerType?'active':'')"> <icon
   :class="'iconfont icon-'+child.icon"
   :style="'color:'+(child.color?child.color:'#3366CC')"
 ></icon>
 <p> {{ child.name }}</p>
  </div>
</el-col>
</el-row>



</div>
<div style="height:20px;" >

</div>
          <div :style="'min-height:' + (scrHeight - 300) + 'px;'">
            <pageInfoShow ref="pageInfoShowRef"> </pageInfoShow>
          </div>
          <hr />
          <div id="ft" class="login-ft PCView">
            <div class="footer-copyright">
              <p class="clearfix links">
                <a href="javascript:;">关于我们</a>
                <a href="javascript:;">法律声明</a>
                <a href="javascript:;">服务条款</a>
                <a href="javascript:;">联系方式</a>
              </p>
              <p style="font-family: arial">
                地址：福建省厦门市集源南里65号&nbsp;&nbsp;增值电信业务许可证B1-20160901&nbsp;&nbsp;COPYRIGHT&nbsp;&nbsp;©&nbsp;
                2024-2036<a href="http://www.teamwish.cn">厦门医学院</a
                >&nbsp;版权所有&nbsp;ICP证：<a href="https://beian.miit.gov.cn"
                  >闽ICP备2024037141号-1</a
                >
              </p>
              <p style="font-family: arial">
                增值电信营业许可证B1-20150962&nbsp;&nbsp;云平台&nbsp;&nbsp;版权所有
              </p>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
  
  </div>
</template>
  
  
  
  
  <script setup>
import appconfig from "@/utils/config"; //常用方法
import { ElMessage, TabsInstance, ElCarousel } from "element-plus";
import { inject, reactive, ref, watch, onMounted } from "vue";
import { isNull, post, Request, navigateTo } from "@/api/common"; //常用方法
//import searchPage from "./hospital/searchpage";
import pageInfoShow from "./base/pageInfoShow";

import bottomTab from "./common/bottomTab";
const carouselRef = ref(null);
// 获取全局对象`
// 获取全局对象`
const global = inject("global");
let carouselHeight = ref(240); //总记录数
const pageInfoShowRef = ref(null);
let ownerType = ref(""); //查询关键字
let scrHeight = ref(600); //总记录数
let datas = ref([]);
let carouselItems = ref([]);
let menuItems = ref([]);

onMounted(() => {
  window.addEventListener("resize", handleResize);
  //获取菜单
  scrHeight.value = window.screen.height - 85;
  var width = window.screen.width;
  if (width < 600) carouselHeight.value = 160;
  else carouselHeight.value = 120;
  /*if (!isNull(global.store.state.userInfo)) {
    //判断下是否有登录
    _LoginUser = global.store.state.userInfo;
    if(Request("openId")!=null&&_LoginUser.openId!= Request("openId")){
      Login();
    }else{
      RetrieveMpModule();
    }
  }else{
    Login();
  }*/
  RetrieveMpModule();
  //ElMessage(scrHeight.value.toString());
});
function handleResize() {
  var width = window.screen.width;
  if (width < 600) carouselHeight.value = 160;
  else carouselHeight.value = 80;
  scrHeight.value = window.screen.height -120;
}

const RetrieveMpModule = function () {
  var param = new Object();
  param.orgCode = appconfig.orgCode;
  post("health/GetMyMpModule", param, function (result) {
    datas.value = result.datas;
    result.datas.forEach((element) => {
      if (element.showType == "9") carouselItems.value = element.children;

      if (element.showType == "4") menuItems.value = element.children;

      /* if(element.showType == '91'){ //保存底部导航选项
        localStorage.setItem("BottomTab", JSON.stringify(element));
      }*/
    });
    if (menuItems.value.length > 0) {
      ownerType.value=menuItems.value[0].name;
      pageInfoShowRef.value.setOwnerType(menuItems.value[0].name);
    }
  });
};

const handlerMenuChange = function (key) {
 // if (keyPath.length < 1) return;
  ownerType.value=menuItems.value[key].name;
  pageInfoShowRef.value.setOwnerType(menuItems.value[key].name);
};

let startX;
const handleTouchStart = (event) => {
  startX = event.touches[0].clientX;
};

const handleTouchEnd = (event) => {
  const currentX = event.changedTouches[0].clientX;
  const delta = currentX - startX;

  if (delta > 100) {
    // 向左滑动
    // 执行上滑操作
    //swapeDown();
    //  carouselRef.value.prev();
  } else if (delta < -100) {
    //向右
    // 向上滑动
    //swapeUp();
    //console.log('向上滑动');
    // carouselRef.value.next();
  }
};
</script>
  
  <style scoped>
.menu-type {
  clear: both;
  margin-bottom: 10px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.col-2-item:nth-child(even) {
  border-left: 1px solid #ccc;
  width: calc(50% - 2px);
}
.login-ft {
  padding-top: 20px;
  padding-bottom: 35px;
  border-top: 1px solid #e5e5e5;
  font-size: 12px;
}
.login-ft .footer-copyright {
  text-align: center;
}
.login-ft .footer-copyright p {
  color: #999;
  margin-top: 10px;
}
.login-ft .footer-copyright p:first-child {
  margin-top: 0;
}
.login-ft .footer-copyright .links a {
  margin-left: 15px;
  color: #666666;
}
.login-ft .footer-copyright .links a:first-child {
  margin-left: 0;
}
.nav-tabs li {
  float: left;
  margin-right: 4px;
}
</style>
